import $ from 'jquery';

const $calculators = $('.calculator');

$calculators.submit(function(e) {
   e.preventDefault();
   const $this = $(this);
   switch ($(this).data('calc')) {
       case 'belt-length':
           beltLength($(this));
           break;
       case 'distance-between-pulleys':
           distanceBetweenPulleys($(this));
           break;
       case 'hp-to-drive-pump':
           hpRequiredToDrivePump($(this));
           break;
       case 'gpm-calc':
           gpm($(this));
           break;
       case 'mci-calc':
           motorCubicInches($(this));
           break;
       case 'motor-rpm-calc':
           motorRPM($(this));
           break;
       case 'flat-storage-capacity':
           flatStorageCapacity($(this));
           break;
       case 'bushels-per-hour':
           bushelsPerHour($(this));
           break;
       case 'capacity':
           capacity($(this));
           break;
       case 'bucket-elevator-rpm-calc':
           bucketElevatorRPM($(this));
           break;
       case 'bucket-elevator-fpm-calc':
           bucketElevatorFPM($(this));
           break;
       case 'straight-pulley-auger-rpm-calc':
           straightPulleyAugerRPM($(this));
           break;
       case 'reduction-box-auger-rpm-calc':
           reductionBoxAugerRPM($(this));
           break;
       case 'feed-density-calc':
           feedDensity($(this));
           break;
       case 'feet-to-tons-calc':
           feetToTons($(this));
           break;
       case 'feed-truck-capacity-calc':
           feedTruckCapacity($(this));
           break;
       case 'feed-truck-needs-calc':
           feedTruckNeeds($(this));
           break;
       case 'hp-inclined-drag-conveyors-calc':
           hpInclinedDragConveyor($(this));
           break;
       case 'hp-horizontal-drag-conveyors-calc':
           hpHorizontalDragConveyor($(this));
           break;
   }
});

$calculators.on('reset', function() {
    hideResults($(this));
});

function formDataToObj (form) {
    const data  = new FormData(form);

    let array = {}
    for (let key of data.keys()) {
        array[key] = data.get(key);
    }

    return array;
}

function showResults($form, result, resultUnit = '', numDecimals = 4) {
    if(isNaN(result)) {
        $form.find('.result-value').text('Invalid input values.');
    } else {
        $form.find('.result-value').text(result.toFixed(numDecimals) + ' ' + resultUnit);
    }
    $form.find('.reset').show();
    $form.find('.calculator__results').addClass('active');
}

function hideResults($form) {
    $form.find('.calculator__results').removeClass('active');
    $form.find('.calculator__results .result-value').val('');
    $form.find('.reset').hide();
}

function showResultsFlatStorage($form, results) {
    $('#grain_peak_height').text(results.grain_peak_height);
    $('#capacity').text(results.capacity);
    $('#length_middle_rect').text(results.length_middle_rect);
    $('#num_bushels_if_walls').text(results.num_bushels_if_walls);
    $('#pile_height').text(results.pile_height);
    $('#num_bushels_conical_end_section').text(results.num_bushels_conical_end_section);
    $('#triangle_height').text(results.triangle_height);
    $('#triangle_width').text(results.triangle_width);
    $('#length_triangular_section').text(results.length_triangular_section);
    $('#num_bushels_triangular_section').text(results.num_bushels_triangular_section);
    $form.find('.reset').show();
    $form.find('.calculator__results').addClass('active');
}

function showResultsCapacity($form, results) {
    $('#bushels_gross').text(results.grossBushelsPerHour);
    $('#bushels_net').text(results.netBushelsPerHour);
    $('#cubic_gross').text(results.grossCubicFeetPerHour);
    $('#cubic_net').text(results.netCubicFeetPerHour);
    $form.find('.reset').show();
    $form.find('.calculator__results').addClass('active');
}

function showResultsFeedTruckNeeds($form, results) {
    $('#loads_per_day').text(results.loadsPerDay);
    $('#setup_per_trailer').text(results.setupTimePerLoadHauled);
    $('#distance_per_day_traveled').text(results.distancePerDayTraveled);
    $('#travel_time_load').text(results.travelTimePerLoad);
    $('#loads_hauled_per_trailer_per_day').text(results.loadsHauledPerTrailerPerDay);
    $('#trailers_required').text(results.trailersRequired);
    $form.find('.reset').show();
    $form.find('.calculator__results').addClass('active');
}

// Convert from degrees to radians.
Math.radians = function(degrees) {
    return degrees * Math.PI / 180;
}

//these are the individual calculator functions
function beltLength($form) {
    const data = formDataToObj($form[0]);
    const result = (data.center_to_center * 2) + ((Number(data.large_pulley) + Number(data.small_pulley)) * 1.57) + (((data.large_pulley - data.small_pulley) ** 2) / (data.center_to_center * 4));
    showResults($form, result);
}

function distanceBetweenPulleys($form) {
    const data = formDataToObj($form[0]);
    const a = (4 * data.length_of_belt) - (6.28 * (Number(data.large_pulley) + Number(data.small_pulley)));
    const result = (a + (Math.sqrt((a ** 2) - (32 * ((data.large_pulley - data.small_pulley) ** 2))))) / 16;
    showResults($form, result);
}

function hpRequiredToDrivePump($form) {
    const data = formDataToObj($form[0]);
    const result = (data.gpm * data.psi) / 1456.9
    showResults($form, result, 'HP');
}

function gpm($form) {
    const data = formDataToObj($form[0]);
    const result = (data.rpm * data.motor_displacement) / 231;
    showResults($form, result, 'GPM');
}

function motorCubicInches($form) {
    const data = formDataToObj($form[0]);
    const result = (data.gpm * 231) / data.rpm;
    showResults($form, result, 'Motor Cubic Inches');
}

function motorRPM($form) {
    const data = formDataToObj($form[0]);
    const result = (data.gpm * 231) / data.motor_displacement;
    showResults($form, result, 'RPM');
}

function flatStorageCapacity($form) {
    const data = formDataToObj($form[0]);
    const lengthMiddleRect = data.grain_length - data.grain_width;
    const numBushelsIfWalls = (Math.PI * (data.grain_width ** 2) / 4 * data.wall_height) / 1.25 + ((data.wall_height * lengthMiddleRect * data.grain_width) / 1.25);
    const pileHeight = (data.grain_width / 2) * (Math.tan(Math.radians(data.angle_repose)));
    const numBushelsConicalSection = 0.209 * (data.grain_width ** 2) * pileHeight;
    const lengthTriangularSection = data.grain_length - data.grain_width;
    const numBushelsTriangularSection = 0.4 * data.grain_width * pileHeight * lengthTriangularSection;
    const grainPeakHeight = pileHeight + Number(data.wall_height);
    const capacity = numBushelsIfWalls + numBushelsConicalSection + numBushelsTriangularSection
    const results = {
        grain_peak_height: grainPeakHeight.toLocaleString('en-US', {maximumFractionDigits:2}),
        capacity: capacity.toLocaleString('en-US', {maximumFractionDigits:2}),
        length_middle_rect: lengthMiddleRect.toLocaleString('en-US', {maximumFractionDigits:2}),
        num_bushels_if_walls: numBushelsIfWalls.toLocaleString('en-US', {maximumFractionDigits:2}),
        pile_height: pileHeight.toLocaleString('en-US', {maximumFractionDigits:2}),
        num_bushels_conical_end_section: numBushelsConicalSection.toLocaleString('en-US', {maximumFractionDigits:2}),
        triangle_height: pileHeight.toLocaleString('en-US', {maximumFractionDigits:2}),
        triangle_width: Number(data.grain_width).toLocaleString('en-US', {maximumFractionDigits:2}),
        length_triangular_section: lengthTriangularSection.toLocaleString('en-US', {maximumFractionDigits:2}),
        num_bushels_triangular_section: numBushelsTriangularSection.toLocaleString('en-US', {maximumFractionDigits:2})
    }

    showResultsFlatStorage($form, results);
}

function bushelsPerHour($form) {
    const data = formDataToObj($form[0]);
    let result = '';
    if(data.unit === "US") {
        result = (((data.bph * 1.25) * data.pounds_per_foot) / 2000);
    } else {
        result = (((data.bph * 1.25) * data.pounds_per_foot) / 2200);
    }
    showResults($form, result);
}

function capacity($form) {
    const data = formDataToObj($form[0]);
    const grossBushelsPerHour = data.cup_capacity * data.spacing_multiplier * data.num_rows * data.fpm * 60 / 2150;
    const netBushelsPerHour = grossBushelsPerHour * .75;
    const grossCubicFeetPerHour = data.cup_capacity * data.spacing_multiplier * data.num_rows * data.fpm * 60 / 1.728;
    const netCubicFeetPerHour = grossCubicFeetPerHour * .75;
    const results = {
        grossBushelsPerHour: grossBushelsPerHour.toLocaleString('en-US', {maximumFractionDigits:2}),
        netBushelsPerHour: netBushelsPerHour.toLocaleString('en-US', {maximumFractionDigits:2}),
        grossCubicFeetPerHour: grossCubicFeetPerHour.toLocaleString('en-US', {maximumFractionDigits:2}),
        netCubicFeetPerHour: netCubicFeetPerHour.toLocaleString('en-US', {maximumFractionDigits:2})
    };
    showResultsCapacity($form, results);
}

function bucketElevatorRPM($form) {
    const data = formDataToObj($form[0]);
    const result = data.rpm / data.gearbox_reduction * data.motor_pulley_diameter / data.pulley_diameter;
    showResults($form, result, 'Head Pulley RPM', 2);
}

function bucketElevatorFPM($form) {
    const data = formDataToObj($form[0]);
    const result = data.pulley_diameter * data.rpm * .2618;
    showResults($form, result, 'Belt FPM', 2);
}

function straightPulleyAugerRPM($form) {
    const data = formDataToObj($form[0]);
    const result = (data.drive_pulley_diameter * data.rpm) / data.driven_pulley_diameter;
    showResults($form, result, 'Auger RPM', 2);
}

function reductionBoxAugerRPM($form) {
    const data = formDataToObj($form[0]);
    const result = ((data.drive_pulley_diameter * data.rpm) / data.driven_pulley_diameter) / data.reduction_ratio;
    showResults($form, result, 'Auger RPM', 2);
}

function feedDensity($form) {
    const data = formDataToObj($form[0]);
    const result = 1728 / 231 * data.container_capacity * (data.container_weight_full - data.container_weight_empty);
    showResults($form, result, 'Feed Density', 2)
}

function feetToTons($form) {
    const data = formDataToObj($form[0]);
    let result = '';
    if(data.unit === "US") {
        result = data.capacity * data.feed_density * .93 / 2000;
        showResults($form, result, 'Tons (U.S)');
    } else {
        result = data.capacity * data.feed_density * .93 / 2204;
        showResults($form, result, 'Tons (Metric)');
    }
}

function feedTruckCapacity($form) {
    const data = formDataToObj($form[0]);
    let result = '';
    if(data.unit === "US") {
        result = ((data.tonnage * 2000) / data.feed_density) / .93;
    } else {
        result = ((data.tonnage * 2204) / data.feed_density) / .93;
    }
    showResults($form, result, 'Cubic Feet');
}

function feedTruckNeeds($form) {
    const data = formDataToObj($form[0]);
    const loadsPerDay = data.tons_per_day / data.tons_per_load;
    const setupTimePerLoadHauled = data.num_setups * data.setup_time;
    const travelTimePerLoad = data.average_hauling_radius * 2 / data.average_speed * 60;
    const loadsHauledPerTrailerPerDay = data.min_per_day / (travelTimePerLoad + setupTimePerLoadHauled + Number(data.loading_time) + Number(data.unloading_time));
    const trailersRequired = loadsPerDay / loadsHauledPerTrailerPerDay;
    const distancePerDayTraveled = trailersRequired * loadsHauledPerTrailerPerDay * data.average_hauling_radius * 2;
    const results = {
        loadsPerDay: loadsPerDay,
        setupTimePerLoadHauled: setupTimePerLoadHauled,
        distancePerDayTraveled: distancePerDayTraveled,
        travelTimePerLoad: travelTimePerLoad,
        loadsHauledPerTrailerPerDay: loadsHauledPerTrailerPerDay.toLocaleString('en-US', {maximumFractionDigits:2}),
        trailersRequired: trailersRequired.toLocaleString('en-US', {maximumFractionDigits:2})
    }
    showResultsFeedTruckNeeds($form, results);
}

function hpInclinedDragConveyor($form) {
    const data = formDataToObj($form[0]);
    const result = ((data.conveyor_length * data.bph) / 55000) + ((data.height * data.bph) / 26500) + ((data.curved_section * data.bph) / 1325);
    showResults($form, result, 'Total Horsepower', 2);
}

function hpHorizontalDragConveyor($form) {
    const data = formDataToObj($form[0]);
    const result = (data.conveyor_length * data.bph) / 55000;
    showResults($form, result, 'Total Horsepower', 2);
}